var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"file-select"},[_c('div',{staticClass:"file-select-button"},[_vm._v("上传")]),_c('input',{staticClass:"file-select-input",attrs:{"type":"file"},on:{"change":_vm.onFileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }